// ** MUI Imports
import { Card, Typography, CardHeader, CardContent, CardActions, Divider, Link } from '@mui/material'
import LayoutContainer from '../common/containers/LayoutContainer'

const HelpCard = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }}
    >
      <Typography
        variant='h6'
        sx={{
          fontWeight: 600,
          color: 'text.header'
        }}
      >
        Support
      </Typography>

      <LayoutContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Typography variant='body2'>
            Our goal is to ensure you have a positive experience and get the most out of Shopflo. Keeping this in mind
            We’ve created a Help Center in order to answer most commonly asked questions on setting up the dashboard and
            how to use the same.
          </Typography>
          <Link
            target='_blank'
            href={'https://shopflo.notion.site/Shopflo-Help-Center-8aa1583893b94dcb84d30f33f2c2129d'}
            sx={{ textDecoration: 'underline', fontSize: 14, fontWeight: 500 }}
          >
            Shopflo Help Center
          </Link>
        </div>
      </LayoutContainer>

      <LayoutContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Typography variant='body2'>In case of any queries, please reach out to us below:</Typography>
          <Typography sx={{ marginRight: '2rem' }} variant='subtitle2'>
            Email:{' '}
            <a href='mailto:support@shopflo.com' style={{ textDecoration: 'none', color: 'inherit' }}>
              support@shopflo.com
            </a>
          </Typography>
          <Typography variant='subtitle2'>
            Phone:{' '}
            <a href='tel:+918105543573' style={{ textDecoration: 'none', color: 'inherit' }}>
              +918105543573
            </a>
          </Typography>
        </div>
      </LayoutContainer>
    </div>
  )
}

export default HelpCard
